import { injectIntl } from "react-intl";
import type { intlFormatPropTypes } from "react-intl";
import { useSelector } from "react-redux";

import { Item } from "@ps-design-system/components/ItemV2";

import { selectProfileSSOid } from "../../app-main/selectors/profile.selectors";
import { trackTodoItemClicked } from "../analytics/host-hub-analytics";
import useHostHubData from "../hooks/useHostHubData";

type HostHubBookingUpdateRequestsItemsProps = {
  intl: intlFormatPropTypes;
};

const HostHubBookingUpdateRequestsItems = ({
  intl,
}: HostHubBookingUpdateRequestsItemsProps) => {
  const ssoid = useSelector(selectProfileSSOid);
  const { reviewBookingUpdates } = useHostHubData();
  const updateRequestCards = reviewBookingUpdates.cards.filter(
    ({ isEligible }) => isEligible,
  );

  const title = intl.formatMessage({
    defaultMessage: "Booking update request",
    id: "host_hub.todo_list.booking_update_request_title",
  });
  const guestNameFallback = intl.formatMessage({
    defaultMessage: "A guest",
    id: "host_hub.todo_list.guest_name_fallback",
  });

  return (
    <>
      {updateRequestCards.map(
        ({
          avatarAlt,
          avatarUrl,
          mediaAlt,
          mediaUrl,
          primaryCtaRoute,
          secondaryData,
          sourceTimestamp,
        }) => {
          const bookingDate = sourceTimestamp
            ? intl.formatDate(new Date(sourceTimestamp), {
                day: "numeric",
                month: "short",
              })
            : "";
          const guestName = secondaryData || guestNameFallback;
          const description = intl.formatMessage(
            {
              defaultMessage:
                "{user_name} has requested an update to their {booking_date} booking",
              id: "host_hub.todo_list.booking_update_request_subtitle",
            },
            {
              booking_date: bookingDate,
              user_name: guestName,
            },
          );

          return (
            <Item
              avatar={avatarUrl}
              avatarAlt={avatarAlt}
              buttonOnClick={() => {
                trackTodoItemClicked({
                  parameter: "booking_update_request",
                  ssoid,
                });
                window.location.assign(primaryCtaRoute);
              }}
              description={description}
              key={`${secondaryData ?? mediaAlt}-${sourceTimestamp ?? ""}`}
              media={mediaUrl}
              mediaAlt={mediaAlt}
              size="lg"
              title={title}
              variant="highlight"
            />
          );
        },
      )}
    </>
  );
};

export default injectIntl(HostHubBookingUpdateRequestsItems);
